import { render, staticRenderFns } from "./CardChartGaugeOrganizationalViolence.vue?vue&type=template&id=45453792&scoped=true&"
import script from "./CardChartGaugeOrganizationalViolence.vue?vue&type=script&lang=js&"
export * from "./CardChartGaugeOrganizationalViolence.vue?vue&type=script&lang=js&"
import style0 from "./CardChartGaugeOrganizationalViolence.vue?vue&type=style&index=0&id=45453792&prod&lang=scss&"
import style1 from "./CardChartGaugeOrganizationalViolence.vue?vue&type=style&index=1&id=45453792&prod&lang=scss&scoped=true&"
import style2 from "./CardChartGaugeOrganizationalViolence.vue?vue&type=style&index=2&id=45453792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45453792",
  null
  
)

export default component.exports